import { render, staticRenderFns } from "./canvasImg.vue?vue&type=template&id=0f2c7e15&scoped=true&"
import script from "./canvasImg.vue?vue&type=script&lang=js&"
export * from "./canvasImg.vue?vue&type=script&lang=js&"
import style0 from "./canvasImg.vue?vue&type=style&index=0&id=0f2c7e15&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2c7e15",
  null
  
)

export default component.exports